import { Button, Typography } from 'omakase';
import { IconBell } from '@tock/icons';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@emotion/react';
import ConsumerBorderCard from 'components/ui/ConsumerBorderCard';

type SoldOutCardProps = {
  businessName: string;
  offeringName: string;
  onJoinWaitlist?: () => void;
};

export const SoldOutCard = ({ businessName, offeringName, onJoinWaitlist }: SoldOutCardProps) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <ConsumerBorderCard className="EventDetailContent-sideSearch">
      <Typography
        variant="body02"
        color="fgSubtle"
        mb={2}
        align={isLargeScreen ? 'left' : 'center'}
      >
        {offeringName} at {businessName} is sold out.
      </Typography>
      {onJoinWaitlist && (
        <Button
          fullWidth={isLargeScreen ? false : true}
          iconStart={<IconBell />}
          onClick={onJoinWaitlist}
          size="medium"
          variant="basic"
        >
          Notify
        </Button>
      )}
    </ConsumerBorderCard>
  );
};
